const LIBRAY_PORTAL = 'library-portal';

const learnerRoutes = {
  LibrayPortalListing: () => `${LIBRAY_PORTAL}`,
  LibrayPortalSubTypes: (assetType: string) => `${LIBRAY_PORTAL}/${assetType}`,
};

export { learnerRoutes };
